import { render } from "./TipTapEditor2.vue?vue&type=template&id=65e66fbb"
import script from "./TipTapEditor2.vue?vue&type=script&lang=js"
export * from "./TipTapEditor2.vue?vue&type=script&lang=js"

import "./TipTapEditor2.vue?vue&type=style&index=0&id=65e66fbb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__